/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { TipusServeiService } from '../../../controllers/TipusServei';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class TipusServeiCreateFormService extends YASAGPostFormService<__model.TipusServei> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    data: new FormGroup({
      id: new FormControl({value: undefined, disabled: false}, []),
      tipus_servei_cat: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(127), Validators.minLength(1), Validators.required]),
      tipus_servei_es: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(127), Validators.minLength(1), Validators.required]),
      tipus_servei_en: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(127), Validators.minLength(1), Validators.required]),
      arees_ca: new FormControl({value: undefined, disabled: false}, []),
      arees_es: new FormControl({value: undefined, disabled: false}, []),
      arees_en: new FormControl({value: undefined, disabled: false}, []),
      h_especific: new FormControl({value: undefined, disabled: false}, []),
      es_poligon: new FormControl({value: undefined, disabled: false}, []),
      missatge_avis_ca: new FormControl({value: undefined, disabled: false}, []),
      missatge_avis_es: new FormControl({value: undefined, disabled: false}, []),
      missatge_avis_en: new FormControl({value: undefined, disabled: false}, []),
      especial: new FormControl({value: undefined, disabled: false}, []),
    }, [Validators.required]),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: TipusServeiService,
  ) {
    super('TipusServeiCreate', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false): Observable<__model.TipusServei> {
    const result = val => this.service.create(val);
    return this._submit('__model.TipusServei', result, 'null', value, false );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.TipusServei> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
